import { render } from "./tamano.vue?vue&type=template&id=27782cd6&scoped=true"
import script from "./tamano.vue?vue&type=script&lang=js"
export * from "./tamano.vue?vue&type=script&lang=js"

import "./tamano.vue?vue&type=style&index=0&id=27782cd6&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27782cd6"]])

export default __exports__